import { EventEmitter, Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { User } from '../models/user';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators';

const LOCALSTORAGE_AUTH_TOKEN_KEY = 'jwt_token';


interface UserResponse {
  user: User;
  access_token: string;
}

@Injectable()
export class Auth {
  user: User;
  sessionTimedOut: EventEmitter<boolean> = new EventEmitter<boolean>();
  returnUrl: string = '/';
  private token: string;
  private authPromise: Promise<boolean>;

  constructor(private http: HttpClient) {
  }

  login(email: string, password: string): Observable<boolean> {
    let body = JSON.stringify({ email, password });
    let headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');

    this.authPromise = null;

    return this.http.post<UserResponse>(`${environment.apiUrl}/auth/login`, body, { headers: headers })
      .pipe(map(response => {
        this.finishAuthentication(response);
        return true;
      }));
  }

  logout(): Observable<boolean> {
    let token = localStorage.getItem(LOCALSTORAGE_AUTH_TOKEN_KEY);
    let headers = new HttpHeaders();

    headers.append('Content-Type', 'application/json');
    headers.append('Authorization', 'Bearer ' + token);

    localStorage.removeItem(LOCALSTORAGE_AUTH_TOKEN_KEY);
    this.user = null;
    this.authPromise = null;

    return this.http.post(`${environment.apiUrl}/auth/logout`, '', { headers: headers })
      .pipe(map(response => {
        localStorage.removeItem(LOCALSTORAGE_AUTH_TOKEN_KEY);
        this.user = null;
        this.authPromise = null;
        return true;
      }));
  }

  getToken(): string {
    return this.token;
  }

  isAuthenticated(): Promise<boolean> {
    if (!this.authPromise) {
      this.authPromise = this.createPromise();
    }

    return this.authPromise;
  }


  finishAuthentication(response: UserResponse): void {
    this.token = response.access_token;
    this.user = new User(response.user);

    localStorage.setItem(LOCALSTORAGE_AUTH_TOKEN_KEY, this.token);
  }

  private validateToken(token): Observable<any> {
    let headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    headers.append('Authorization', 'Bearer ' + token);

    return this.http.get<UserResponse>(`${environment.apiUrl}/auth/user`, { headers: headers })
      .pipe(map(response => {
        this.user = new User(response.user);
      }));
  }

  private createPromise() {
    this.token = localStorage.getItem(LOCALSTORAGE_AUTH_TOKEN_KEY);

    return new Promise<boolean>(resolve => {
      if (this.user) {
        resolve(true);
      }

      if (this.token) {
        console.log('ok!');
        this.validateToken(this.token)
          .subscribe(json => {
            resolve(true);
          }, err => {
            resolve(false);
          });
      } else {
        resolve(false);
      }
    });
  }

  createResetToken(email: string) {
    let body = JSON.stringify({ email });
    return this.http.post<any>(`${environment.apiUrl}/password/email`, body)
      .pipe(map(response => {
        return true;
      }));
  }

  resetPassword(email: string, password: string, token: string) {
    let body = JSON.stringify({ email, token, password, 'password_confirmation': password });
    return this.http.post<any>(`${environment.apiUrl}/password/reset`, body)
      .pipe(map(response => {
        return true;
      }));
  }
}



// WEBPACK FOOTER //
// ./src/app/auth/auth.service.ts